<template>
  <v-container fluid class="region-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Region</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Region</p>
                        <v-text-field
                          class="mb-4"
                          v-model="region.regioncode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Region Code"
                          persistent-hint
                          single-line hint="Enter the region code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="region.regionname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Region Name"
                          persistent-hint
                          single-line hint="Enter the region name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="region.regioninfo"
                          outlined
                          dense
                          placeholder="Info Text"
                          persistent-hint
                          single-line hint="Enter the info text">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=regiontype
                          v-model="region.regiontype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the region type">
                        </v-select>
                          <v-switch
                            v-model="region.regionstatus"
                            color="primary"
                            v-bind:label="region.regionstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/region/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createRegion()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      region: {
        regionstatus: 'Active'
      },
      regiontype: ['Division', 'State', 'Province'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Region', ['insertRegionRequest','getRegionsRequest']),
    checkError(){
      if(!this.region.regioncode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.region.regionname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.region.regiontype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async createRegion() {
      if(!this.checkError()) return;
      await this.insertRegionRequest(this.region);
      await this.getRegionsRequest();
      router.push('/region/list');
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.region.regionimage = file;
      this.region.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Region', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
